import { createActionCreator } from 'deox';

import { TCreateProjectBody, TCreateProjectResponse } from '@/services/api/project/create-project';

// CONSTANTS

export enum ECreateProjectAction {
  CREATE_PROJECT = 'CREATE_PROJECT',
  CREATE_PROJECT_REQUEST = 'CREATE_PROJECT_REQUEST',
  CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS',
  CREATE_PROJECT_FAILED = 'CREATE_PROJECT_FAILED',
}

// TYPES

export type TCreateProjectRequest = {
  type: ECreateProjectAction.CREATE_PROJECT_REQUEST;
  payload: {
    materials: TCreateProjectBody;
    companyId: number;
    successCallback?: (response: TCreateProjectResponse) => void;
    failedCallback?: (err: unknown) => void;
  };
};

export type TCreateProjectSuccess = {
  type: ECreateProjectAction.CREATE_PROJECT_SUCCESS;
  payload: { response: TCreateProjectResponse };
};

export type TCreateProjectFailed = { type: ECreateProjectAction.CREATE_PROJECT_FAILED };

// FUNCTION

export const createProjectAction = {
  request: createActionCreator(
    ECreateProjectAction.CREATE_PROJECT_REQUEST,
    (resolve) =>
      (
        materials: TCreateProjectBody,
        companyId: number,
        successCallback?: (response: TCreateProjectResponse) => void,
        failedCallback?: (err: unknown) => void,
      ): TCreateProjectRequest =>
        resolve({ materials, companyId, successCallback, failedCallback }),
  ),
  success: createActionCreator(
    ECreateProjectAction.CREATE_PROJECT_SUCCESS,
    (resolve) =>
      (response: TCreateProjectResponse): TCreateProjectSuccess =>
        resolve({ response }),
  ),
  failure: createActionCreator(
    ECreateProjectAction.CREATE_PROJECT_FAILED,
    (resolve) =>
      (error: any): TCreateProjectFailed =>
        resolve({ error }),
  ),
};
